<template>
    <div>
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" :height="150" :width="150"
            :color="'#FFFF00'" :background-color="'#000000'" :opacity="0.5"></loading>
        <v-container>
            <v-form v-if="!isLoading">
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}</h2>
                </v-row>
                <v-container id="scroll-target" class="custom-form overflow-y-auto px-5">
                <v-row>
                    <v-col cols="10" sm="10" class="pb-n4">
                        <v-autocomplete outlined dense :label="$t('acknowledgement.selectacknowledgementtype')"
                            :rules="[rules.required]" v-model="formData.ackTypeId" :items="ackTypeOptionList"
                            @input="updateValue" :readonly="notAllowToEdit" :class="{ 'readonly-bg': notAllowToEdit }">
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="10" sm="10" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('acknowledgement.acknowledgementname')" type="text"
                            :rules="[rules.required]" v-model="formData.ackName" @input="updateValue" class="v-input"
                            dense :readonly="notAllowToEdit" :class="{ 'readonly-bg': notAllowToEdit }">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="10" sm="10" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="this.$t('acknowledgement.acknowledgementlongdesc')" type="text"
                            :rules="[rules.required]" v-model="formData.ackLongDesc" @input="updateValue"
                            class="v-input" dense :readonly="notAllowToEdit" :class="{ 'readonly-bg': notAllowToEdit }">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('acknowledgement.createdate')" type="date"
                            :rules="[rules.required]" v-model="formData.createDate" @input="updateValue" class="v-input"
                            dense :readonly="notAllowToEdit" :class="{ 'readonly-bg': notAllowToEdit }"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('acknowledgement.publishdate')" type="date"
                            :rules="[rules.required]" v-model="formData.publishDate" @input="updateValue"
                            class="v-input" dense :readonly="notAllowToEdit"
                            :class="{ 'readonly-bg': notAllowToEdit }"></v-text-field>
                    </v-col>
                    <v-col cols="3" sm="3" class="pb-n4 mt-n8">
                        <v-checkbox outlined v-model="formData.suspendStatus" :label="$t('acknowledgement.suspend')"
                            @input="updateValue" @change="updateValue" class="v-input" dense></v-checkbox>
                    </v-col>
                </v-row>
                <div class="pb-4 block">
                    <v-row>
                        <v-col cols="10" sm="10" class="pb-4 mt-n8">
                            <VueEditor ref="content" v-model="formData.content" @input="onEditorInput" outlined dense
                                type="text" :label="$t('letterlist.content')" :editor-toolbar="customToolbar"
                                :class="{ 'editor-read-only-bg': notAllowToEdit }" />
                        </v-col>
                    </v-row>
                </div>
                <v-row>
                    <v-col cols="10" sm="10" class="pb-n4">
                        <v-text-field outlined :label="$t('columns.remark')" type="text" ref="remark"
                            v-model="formData.remark" dense rows="1"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="10" sm="10" class="pb-n4 mt-n8">
                        <v-file-input ref="attach"
                            :label="formData.attach ? formData.attachname : this.$t('recdisciplinaryrec.supportingdoc')"
                            outlined v-model="fileHolder" @change="fileToBase64" @input="updateValue"
                            dense></v-file-input>
                    </v-col>
                </v-row>
                <div v-if="isEdit && formData.attach">
                    <v-row>
                        <v-col cols="4" sm="4" class="ml-1 mt-n5">
                            <p>
                                <a v-bind:href="this.formData.attach" v-bind:download="this.formData.attachname"
                                    style="display: inline-block; padding: 4px 8px; cursor: pointer; color: blue; text-decoration: underline;">
                                    {{ formData.attachname }}
                                </a>
                                <v-icon small class="ml-3 mr-2" @click="deleteAttachmentHandlerNew">
                                    mdi-delete
                                </v-icon>
                            </p>
                        </v-col>
                    </v-row>
                </div>
                <v-row class="mt-n5">
                    <v-col cols="6" sm="6" class="blue--text text-h6" ref="CRUDSection">
                        {{ $t('columns.company') }}
                    </v-col>
                </v-row>
                <v-row class="mt-n5">
                    <v-col class="py-0 px-3">
                        <p style="color: #94A3B8; font-size: 0.82rem; margin: 0 0 4px; text-transform: none;">{{ $t('acknowledgement.crudstatement') }}</p>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="10" class="pb-4">
                        <app-table v-bind:parentObject="{
                            tabHeader: this.tabHeader,
                            ackRecordId: this.formData.id,
                            detailItemList: this.formData.detailItemList,
                            notAllowToEdit: this.notAllowToEdit,
                        }" v-on:input="addItemHandler" />
                    </v-col>
                </v-row>

                </v-container>
                <app-formbuttons v-on:SavePressed="saveHandler" v-on:CancelPressed="cancelHandler" />
            </v-form>
        </v-container>
    </div>
</template>

<script>
import CRUDTable from "./CRUDTable";
import moment from "moment";
import Loading from "vue-loading-overlay";
import { Quill } from "vue2-editor";

// Generate code-friendly font names
function getFontName(font) {
    return font.toLowerCase().replace(/\s/g, "-");
}

// Specify Quill fonts
const fontList = ['Arial', 'Courier', 'Garamond', 'Tahoma', 'Times New Roman', 'Verdana'];
const fontNames = fontList.map(font => getFontName(font));
const fonts = Quill.import('formats/font');
fonts.whitelist = fontNames;
Quill.register(fonts, true);
const fontSizeArr = ['10px', '14px', '18px', '22px'];
var Size = Quill.import('attributors/style/size');
Size.whitelist = fontSizeArr;
Quill.register(Size, true);

// Add fonts to CSS style
let fontStyles = "";
fontList.forEach(function (font) {
    let fontName = getFontName(font);
    fontStyles += ".ql-snow .ql-picker.ql-font .ql-picker-label[data-value=" + fontName + "]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=" + fontName + "]::before {" +
        "content: '" + font + "';" +
        "font-family: '" + font + "', sans-serif;" +
        "}" +
        ".ql-font-" + fontName + "{" +
        " font-family: '" + font + "', sans-serif;" +
        "}";
});
fontStyles += `.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {
    content: 'Small';
    font-size: 10px !important;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
    content: 'Normal';
    font-size: 14px !important;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
    content: 'Large';
    font-size: 18px !important;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="22px"]::before {
    content: 'Huge';
    font-size: 22px !important;
}`

const node = document.createElement('style');
node.innerHTML = fontStyles;
document.body.appendChild(node);

export default {
    props: {
        parentObject: Object
    },

    components: {
        Loading,
        "app-table": CRUDTable,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            customToolbar: [
                [{ 'size': Size.whitelist }],
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                [{ 'font': fonts.whitelist }],
                ["bold", "italic", "underline"], // toggled buttons
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                ["blockquote", "code-block"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ color: [] }], // dropdown with defaults from theme
                ["image"],
            ],

            formData: {
                id: this.parentObject.data.id,
                ackTypeId: this.parentObject.data.ackTypeId,
                ackName: this.parentObject.data.ackName,
                ackLongDesc: this.parentObject.data.ackLongDesc,
                createDate: this.parentObject.data.createDate,
                publishDate: this.parentObject.data.publishDate,
                suspendStatus: this.parentObject.data.suspendStatus,
                remark: this.parentObject.data.remark,
                content: this.parentObject.data.content,
                detailItemList: this.parentObject.data.detailItemList,
                attach: this.parentObject.data.attach,
                attachname: this.parentObject.data.attachname,
                stamp: this.parentObject.data.stamp,
                updatedby: this.$store.getters.userId,
            },
            fileHolder: null,

            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '150px', sortable: false },
                { text: this.$t('columns.company'), value: 'companyCode', width: '150px', sortable: false },
                { text: this.$t('attendancereportbypeiordbycompanyreport.companyname'), value: 'companyName', width: '250px', sortable: false },
            ],

            isErr: false,
            errMsg: '',
            isEdit: this.parentObject.isEdit,
            isLoading: true,

            notAllowToEdit: false, // default:allow to edit which is false, 
            // use to check if the current date and suspend status, can edit data or not

            ackTypeOptionFull: [],
            ackTypeOptionList: [], // take necessary data only from Full
        }
    },

    watch: {
        notAllowToEdit(newVal) {
            this.$nextTick(() => {
                if (this.$refs.content && this.$refs.content.quill) {
                    this.$refs.content.quill.enable(!newVal);
                }
            });
        },
    },

    methods: {
        saveHandler() {
            this.updateValue();
            this.$emit('save');
        },

        cancelHandler() {
            this.$router.push({ name: 'acknowledgementgrid' });
        },

        onEditorInput() {
            this.updateValue();
            this.adjustEditorHeight();
        },

        adjustEditorHeight() {
            this.$nextTick(() => {
                const editor = this.$refs.content?.quill;
                if (!editor) return;

                const editorEl = editor.root; // the .ql-editor element
                const containerEl = editor.container; // .ql-container

                // reset to auto so scrollHeight is correct
                editorEl.style.height = 'auto';
                const newHeight = editorEl.scrollHeight;

                // optional min/max bounds
                const minHeight = 120;
                const maxHeight = 99999;
                const finalHeight = Math.max(minHeight, Math.min(maxHeight, newHeight));

                // apply height to both elements
                editorEl.style.height = finalHeight + 'px';
                containerEl.style.height = finalHeight + 'px';
            });
        },

        updateValue() {
            this.$emit('input', {
                id: this.formData.id,
                ackTypeId: this.formData.ackTypeId,
                ackName: this.formData.ackName,
                ackLongDesc: this.formData.ackLongDesc,
                createDate: this.formData.createDate,
                publishDate: this.formData.publishDate,
                suspendStatus: this.formData.suspendStatus,
                content: this.formData.content,
                remark: this.formData.remark,
                attach: this.formData.attach,
                attachname: this.formData.attachname,
                detailItemList: this.formData.detailItemList,
                stamp: this.formData.stamp,
                updatedby: this.formData.updatedby,
            });
        },

        addItemHandler($event) {
            this.formData.detailItemList = $event
            this.updateValue();
        },

        async AckTypeListHandler() {
            const vm = this;
            try {
                const res = await this.$store.dispatch('get', { url: '/acknowledgementtype/all' });

                vm.ackTypeOptionFull = res.data.rec;
                vm.ackTypeOptionList = []; // Reset before adding new items
                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.ackTypeOptionList.push({
                        text: res.data.rec[i].ackTypeName,
                        value: res.data.rec[i].id,
                    });
                }
            } catch (err) {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            }
        },

        downloadFile() {
            console.log('downloadFile', this.formData.attach, this.formData.attachname)
            const link = document.createElement("a");
            link.href = this.formData.attach;
            link.download = this.formData.attachname;
            link.click();
        },

        fileToBase64() {
            if (this.fileHolder) {
                var file = this.$refs.attach.internalValue;
                this.formData.attachname = this.fileHolder.name

                var reader = new FileReader();

                reader.onloadend = async () => {
                    const base64 = reader.result;

                    if (base64.includes('image')) {
                        try {
                            const resizedBase64 = await this.resizeImage(base64, 300); // Adjust maxSizeKB as needed
                            this.formData.attach = resizedBase64;
                        } catch (err) {
                            console.error('Image resize error:', err.message);
                            this.formData.attach = base64; // fallback to original base64 if resize fails
                        }
                    } else {
                        this.formData.attach = base64; // for non-images like PDFs
                    }
                };

                reader.readAsDataURL(file);
            } else {
                this.formData.attach = null
            }
        },

        checkSize(dataURI, maxSizeKB) {
            return new Promise((resolve, reject) => {
                let regex = null;
                if (dataURI.includes('application')) {
                    regex = /^data:application\/[^;]+;base64,/i;
                }
                else if (dataURI.includes('image')) {
                    regex = /^data:image\/[^;]+;base64,/i;
                }
                if (!regex) {
                    reject(new Error('Unsupported file type.'));
                    return;
                }
                const matches = dataURI.match(regex);
                if (!matches) {
                    reject(new Error('Invalid Data URI.'));
                    return;
                }
                // const stringLength = dataURI.length - matches.length;
                const sizeInBytes = (dataURI.length - matches[0].length) * (3 / 4); // Convert Base64 to bytes
                const sizeInKB = sizeInBytes / 1024; //Convert to KB
                resolve(sizeInKB <= maxSizeKB);
            });
        },

        resizeImage(dataURI, maxSizeKB, maxAttempts = 10) {
            return new Promise((resolve, reject) => {
                if (dataURI.includes('image')) {
                    this.checkSize(dataURI, maxSizeKB).then(sizeOK => {
                        if (sizeOK) {
                            return resolve(dataURI);
                        }

                        const resizeAndCheck = (dataURI, attempt = 1) => {
                            if (attempt > maxAttempts) {
                                return reject(new Error('Image size exceeds the maximum allowed size.'));
                            }

                            const image = new Image();
                            image.onload = () => {
                                const canvas = document.createElement('canvas');
                                const ctx = canvas.getContext('2d');

                                let width = image.width;
                                let height = image.height;
                                const maxDim = 800;

                                if (width > height) {
                                    if (width > maxDim) {
                                        height = height * (maxDim / width);
                                        width = maxDim;
                                    }
                                } else {
                                    if (height > maxDim) {
                                        width = width * (maxDim / height);
                                        height = maxDim;
                                    }
                                }

                                canvas.width = width;
                                canvas.height = height;

                                ctx.drawImage(image, 0, 0, width, height);
                                const resizedDataURI = canvas.toDataURL('image/jpeg', 0.6);

                                this.checkSize(resizedDataURI, maxSizeKB).then(ok => {
                                    if (ok) {
                                        resolve(resizedDataURI);
                                    } else {
                                        resizeAndCheck(resizedDataURI, attempt + 1);
                                    }
                                }).catch(reject);
                            };

                            image.onerror = () => reject(new Error('Failed to load image for resizing.'));
                            image.src = dataURI;
                        };

                        resizeAndCheck(dataURI);
                    }).catch(reject);
                } else if (dataURI.includes('application')) {
                    this.checkSize(dataURI, maxSizeKB).then(sizeOK => {
                        if (sizeOK) resolve(dataURI);
                        else reject(new Error('File size exceeds the maximum allowed size.'));
                    }).catch(reject);
                } else {
                    reject(new Error('Unsupported file type.'));
                }
            });
        },

        deleteAttachmentHandlerNew() {
            this.formData.attach = ''
            this.formData.attachname = ''
        },

    },
    async mounted() {
        try {
            this.isLoading = true;

            await this.AckTypeListHandler();

            this.$nextTick(() => {
                // Ensure initial sizing when loaded
                this.adjustEditorHeight();

                // Also observe content changes (if loaded async)
                const editor = this.$refs.content?.quill;
                if (editor) {
                    editor.on('text-change', () => {
                        this.adjustEditorHeight();
                    });
                }
            });

            if (this.isEdit) {
                const currentDate = moment();
                const publishDate = moment(this.formData.publishDate);
                const suspendStatus = this.formData.suspendStatus === true || this.formData.suspendStatus === 1;

                // console.log("Current Date:", currentDate.format("YYYY-MM-DD"));
                // console.log("Publish Date:", publishDate.format("YYYY-MM-DD"));
                // console.log("Suspend Status:", suspendStatus);

                // Default:  editable
                this.notAllowToEdit = false;

                // ✅ Editable conditions:
                if (suspendStatus) {
                    //if suspend, not matter what, allow to edit, which set to false
                    this.notAllowToEdit = false;
                }
                else if (currentDate.isSameOrAfter(publishDate, 'day')) {
                    //if current date is after publish date, then we dont allow edit, set to true
                    this.notAllowToEdit = true;
                }

                // console.log("Not Allow To Edit:", this.notAllowToEdit);
                if (this.notAllowToEdit && this.$refs.content?.quill) {
                    this.$refs.content.quill.enable(false);
                }
            }
            // console.log("parent data", this.parentObject.data);
            this.isLoading = false;

        } catch (error) {
            this.isErr = true;
            this.errMsg = error;
            this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            console.error("Error loading data:", error);
        }
    },
};
</script>

<style scoped>
/* this is use to normal input readonly*/
::v-deep(.readonly-bg .v-input__control .v-input__slot) {
    background-color: #FFFDD0 !important;
    border-radius: 6px;
}

.block {
    display: block;
    width: 100%;
}

/* ✅ Use ::v-deep so styles apply inside VueEditor (Quill’s DOM) */
::v-deep(.editor-read-only-bg .ql-container) {
    background-color: #fffdd0 !important;
    cursor: default !important;
}

::v-deep(.editor-read-only-bg .ql-editor) {
    background-color: #fffdd0 !important;
    cursor: default !important;
}

::v-deep(.editor-read-only-bg .ql-toolbar) {
    opacity: 0.6;
    pointer-events: none;
}

/* Optional: make resizing stable */
.v-col {
    min-width: 0;
}

::v-deep(.ql-editor) {
    overflow-y: hidden;
    /* hide scrollbar */
    min-height: 120px;
    transition: height 0.1s ease-out;
}

::v-deep(.ql-container) {
    height: auto !important;
}
</style>